/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Chkk API v1.0
 * Chkk API for Kubernetes deployment and upgrade safety.
 * OpenAPI spec version: v1.0
 */

/**
 * The format of the export
 */
export type UpgradeExportFormat =
  (typeof UpgradeExportFormat)[keyof typeof UpgradeExportFormat];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpgradeExportFormat = {
  markdown: 'markdown',
  'simple-markdown': 'simple-markdown',
  pdf: 'pdf',
} as const;
